/* Holiday MRKT 2026 page: scroll reveals, schedule tabs/filters, FAQ, sticky ticket bar. (Vendor grids render in Liquid.) */
(function () {
  'use strict';
  if (window.HM26_LOADED) return; // each section includes this file; run it once
  var docEl = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.HM26_LOADED = true;

  /* ---------- scroll reveal ---------- */
  var io = null;
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.hm26-r:not(.is-in), .hm26-r-img:not(.is-in), .hm26-rule:not(.is-in), .fsvg__tile:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- schedule ---------- */
  function initSchedule(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var state = { day: 'sat', tag: 'all' };
    var tabs = root.querySelectorAll('[data-hm-day]');
    var chips = root.querySelectorAll('[data-hm-tag]');
    var acts = root.querySelectorAll('.hm26-act');
    var countEl = root.querySelector('[data-hm-count]');
    function apply() {
      var n = 0;
      acts.forEach(function (a) {
        var d = a.getAttribute('data-day');
        var tags = (a.getAttribute('data-tags') || '').split(' ');
        var ok = (d === 'both' || d === state.day) && (state.tag === 'all' || tags.indexOf(state.tag) !== -1);
        a.hidden = !ok;
        if (ok) n++;
      });
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-hm-day') === state.day ? 'true' : 'false'); });
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-hm-tag') === state.tag ? 'true' : 'false'); });
      if (countEl) {
        var label = state.day === 'sat' ? root.getAttribute('data-day1') : root.getAttribute('data-day2');
        countEl.textContent = n + (n === 1 ? ' activity' : ' activities') + ' on ' + label + '.';
      }
      reveal(root);
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { state.day = t.getAttribute('data-hm-day'); apply(); }); });
    chips.forEach(function (c) { c.addEventListener('click', function () { state.tag = c.getAttribute('data-hm-tag'); apply(); }); });
    apply();
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    root.querySelectorAll('.hm26-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- sticky ticket bar (sits under the theme's sticky header) ---------- */
  function initBar() {
    var bar = document.querySelector('.hm26-bar');
    if (!bar || bar.dataset.ready) return; bar.dataset.ready = '1';
    var wrap = bar.closest('.shopify-section') || bar.parentElement;
    wrap.classList.add('hm26-bar-sticky');
    var stuck = [];
    function collect() {
      // the theme header's sticky/fixed elements (anything above the bar in the page with position fixed/sticky)
      stuck = [];
      var hdr = document.querySelector('[id^="shopify-section"][id$="header"], header, .site-header');
      if (!hdr) return;
      [hdr].concat(Array.prototype.slice.call(hdr.querySelectorAll('*'), 0, 400)).forEach(function (el) {
        var p = getComputedStyle(el).position;
        if ((p === 'sticky' || p === 'fixed') && !el.contains(bar)) stuck.push(el);
      });
    }
    var ticking = false;
    function update() {
      ticking = false;
      var top = 0;
      stuck.forEach(function (el) {
        // measure the stuck element and its direct children (some headers use a 0-height fixed wrapper around an absolute bar)
        [el].concat(Array.prototype.slice.call(el.children)).forEach(function (c) {
          var r = c.getBoundingClientRect();
          // ignore closed drawers/menus: must be on screen, short (not a full-height panel) and visible
          if (!r.height || r.height > window.innerHeight * 0.4 || r.right <= 0 || r.left >= window.innerWidth || r.bottom <= 0) return;
          if (getComputedStyle(c).visibility === 'hidden') return;
          if (r.top <= 1 && r.bottom > top) top = r.bottom;
        });
      });
      top = Math.max(0, Math.round(top));
      docEl.style.setProperty('--hm26-bar-top', top + 'px');
      // in-page jumps (#faq, #getting-there) stop below the sticky header + ticket bar
      docEl.style.scrollPaddingTop = (top + bar.offsetHeight + 16) + 'px';
      bar.classList.toggle('is-stuck', wrap.getBoundingClientRect().top <= top + 1 && window.scrollY > 0);
    }
    var lastCollect = Date.now();
    function onScroll() {
      // some headers only turn fixed after you start scrolling, so look again now and then
      if (Date.now() - lastCollect > 1000) { lastCollect = Date.now(); collect(); }
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    collect(); update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { collect(); onScroll(); });
  }

  /* ---------- back to top ---------- */
  function initTop() {
    if (document.querySelector('.hm26-totop') || !document.querySelector('.hm26')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hm26-totop';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 10l5-5 5 5"/></svg>';
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    document.body.appendChild(btn);
    var on = false, t = false;
    function check() { t = false; var show = window.scrollY > window.innerHeight * 0.9; if (show !== on) { on = show; btn.classList.toggle('is-on', on); } }
    window.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }

  /* ---------- boot ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hm26-schedule]').forEach(initSchedule);
    scope.querySelectorAll('[data-hm26-faq]').forEach(initFaq);
    initBar();
    initTop();
    reveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
